import type { ReactNode } from 'react';
import { cn } from '@/shared/utils/cn';

type SectionProps = {
  title?: string;
  description?: string;
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  action?: ReactNode;
};

export const Section = ({
  title,
  description,
  children,
  className,
  contentClassName,
  action,
}: SectionProps) => (
  <section className={cn('rounded-2xl border border-slate-200 bg-white p-4 shadow-card', className)}>
    {(title || action) && (
      <header className="mb-3 flex items-start justify-between gap-2">
        <div>
          {title && <h2 className="text-sm font-semibold uppercase tracking-wide text-ink-muted">{title}</h2>}
          {description && <p className="mt-1 text-xs text-ink-muted">{description}</p>}
        </div>
        {action && <div>{action}</div>}
      </header>
    )}
    <div className={cn('flex flex-col gap-3', contentClassName)}>{children}</div>
  </section>
);
